import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { ValidatorService } from 'app/core/services/validator.service';
import { Definition } from 'app/core/store/definitions/definition.interface';

@Component({
  selector: 'stock-count-create-location',
  templateUrl: './stock-count-create-location.component.html',
  styleUrls: ['./stock-count-create-location.component.scss', '../../../florders/florder-page-container/florder-page.container.scss'],
})
export class StockCountLocationComponent implements OnInit, OnChanges {
  stockCountLocationForm: UntypedFormGroup;
  shipTosLoading = false;

  @Input() isSaving: boolean;
  @Input() shipTos: Definition[];
  @Input() isPrint: boolean = false;

  @Output() selectedShipTo: EventEmitter<string> = new EventEmitter();

  sandbox: StockCountSandbox;

  constructor(private formBuilder: UntypedFormBuilder, private validatorService: ValidatorService, private translate: TranslateService, sandbox: StockCountSandbox) {
    this.sandbox = sandbox;
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shipTos) {
      this.shipTosLoading = false;
      let theOnlyShipTo = this.shipTos && this.shipTos.length === 1 && this.shipTos[0];
      if (theOnlyShipTo && this.stockCountLocationForm) {
        this.stockCountLocationForm.get('shipTo').setValue(theOnlyShipTo);
      }
    }
  }

  private createForm() {
    let theOnlyShipTo = this.shipTos && this.shipTos.length === 1 && this.shipTos[0];
    this.stockCountLocationForm = this.formBuilder.group({
      shipToId: [theOnlyShipTo?.id || null, [Validators.required]],
    });
  }

  loadStockCounts() {
    const selectedShipToId: string = this.stockCountLocationForm.value['shipToId'];
    if (selectedShipToId) {
      if (!this.isPrint) {
        this.sandbox.getStockCountOrderList(selectedShipToId);
        this.selectedShipTo.emit(selectedShipToId);
      } else {
        this.sandbox.printStockCounty(selectedShipToId);
      }
    }
  }
}
